import React from 'react';
import styles from './LayoutItem.module.scss';
import cs from 'classnames';
import H from '../../H/H';
import ListItem from '../ListItem';
export default function LayoutItem(_ref) {
  var level = _ref.level,
    id = _ref.id,
    name = _ref.name,
    children = _ref.children,
    orientation = _ref.orientation;
  return /*#__PURE__*/React.createElement(ListItem, {
    className: styles["item-".concat(orientation, "-").concat(level)]
  }, /*#__PURE__*/React.createElement(H, {
    id: id,
    dangerouslySetInnerHTML: {
      __html: name
    },
    className: cs(styles.heading, styles[orientation])
  }, null), children);
}